<template>
         <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
          <v-card-title>Liste des transmissions</v-card-title>
     <v-card-text>
      <v-container>
           <v-data-table 
           style="border-color: #0a42da;border-style: solid;border-width: 0.1px;"
      :headers="headers"
      :items="listdata"
      :search="search"
      no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"
    >
    <template v-slot:[`item.createdOn`]="{ item }">       
        {{ $formatDate(item.createdOn) }}
      </template>
    <template v-slot:[`item.actions`]="{ item,index}">
     
      <v-btn  flat @click="deleteItem(item,index)" title="Supprimer la transmission">
      <v-icon
        size="small"
        
      >
        mdi-delete
      </v-icon>
      </v-btn>
      <v-btn flat @click="downloadPdf(item.id)" title="Télécharger la transmission"><v-icon
        size="small"
        
      >
        mdi-download
      </v-icon></v-btn>
    </template>

    </v-data-table>
    </v-container>
    </v-card-text>
    </v-card-item>
    </v-card>
</template>
<script>
import http from '../http.js';
export default{
    data() {
        return {
         
            creation:false,
            search: '',
            headers: [{"title": "Statut", "key": "statut"},{ "title": "Date d'envoi", "key": "createdOn" }, { "title": "Email du destinataire", "key": "email" }, {"title": "Patient", "key": "patient.nom" }, { "title": "Actions", "key": "actions" }],
            data: {},
            listdata:[]
        };
    },
    computed() {

      
    },
    mounted() {
      this.list()
        
    },
    methods: {
      list(){
        
            http.get('/api/transmission')
            .then(response => { this.listdata = response.data; });
      },
      deleteItem(item,index){

        if(confirm('Etes vous sur de la suppresion du medecin '+item.nom+" "+item.prenom+" ?")){
            http.delete("/api/transmission/"+item.id)
            this.listdata.splice(index, 1);
        }
       },
       async downloadPdf(id) {
      try {
        const response = await http.get('/api/'+id+'/download', {
          responseType: 'blob', // Important pour gérer les fichiers binaires
        });

        // Créer un blob pour le fichier PDF
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // Créer un lien pour télécharger le fichier
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'fichier.pdf'; // Nom du fichier
        link.click();

        // Nettoyer l'URL du blob après utilisation
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error('Erreur lors du téléchargement du fichier :', error);
      }
    }
    }
    }
</script>